__turbopack_context__.v({
  "actionsContainer": "_3ONZ1G_actionsContainer",
  "actionsRow": "_3ONZ1G_actionsRow",
  "actionsTitle": "_3ONZ1G_actionsTitle",
  "buttonRow": "_3ONZ1G_buttonRow",
  "buttonText": "_3ONZ1G_buttonText",
  "buttonWrapper": "_3ONZ1G_buttonWrapper",
  "buttonsContainer": "_3ONZ1G_buttonsContainer",
  "copyButton": "_3ONZ1G_copyButton",
  "tooltip": "_3ONZ1G_tooltip",
});
